//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {

	name: "hub-notification-manager",

	props: {

		namespace: {
			required: true,
			type: String
		}

	},

	data()
	{
		return {
			isLoading: false
		};
	}

}

